/**
 * <Section num="01" title="Trust"> ... </Section>
 *
 * Renders the standard "numbered section heading + accent rule + body" pattern
 * used across every content page.
 */
export function Section({ id, num, title, children }) {
  return (
    <section id={id} className="mb-14 scroll-mt-6">
      <h3 className="h-section">
        <span className="num">{num}</span>
        {title}
      </h3>
      <div className="section-rule" />
      {children}
    </section>
  );
}

export function SubHead({ children }) {
  return <h4 className="h-sub">{children}</h4>;
}
